import { useEffect, useState } from 'react';
import './LiksBrand.css';

const DEFAULT_LOGO_SRC = '/liks-logo.png';

export type LiksBrandProps = {
  showText?: boolean;
  logoSrc?: string;
  className?: string;
};

export function LiksBrand({
  showText = true,
  logoSrc = DEFAULT_LOGO_SRC,
  className,
}: LiksBrandProps) {
  const [displaySrc, setDisplaySrc] = useState(logoSrc);
  const classNames = ['liks-brand', className].filter(Boolean).join(' ');

  useEffect(() => {
    // Reset to the requested src when it changes so a new logo can retry render.
    // eslint-disable-next-line react-hooks/set-state-in-effect -- sync derived UI flag to prop change
    setDisplaySrc(logoSrc);
  }, [logoSrc]);

  return (
    <div className={classNames}>
      <span className="liks-brand__icon" aria-hidden>
        <img
          className="liks-brand__image"
          src={displaySrc}
          alt=""
          onError={() => {
            if (displaySrc !== DEFAULT_LOGO_SRC) {
              setDisplaySrc(DEFAULT_LOGO_SRC);
            }
          }}
        />
      </span>
      {showText && <span className="liks-brand__text">LIKS</span>}
    </div>
  );
}
